import { SxProps } from '@mui/material';
import { Theme } from '@mui/system';

export const getContainerStyle = (color: string): SxProps<Theme> => ({
  '& .pro-sidebar-inner': {
    background: `${color} !important`,
  },
  '& .pro-icon-wrapper': {
    backgroundColor: 'transparent !important',
  },
  '& .pro-inner-item': {
    padding: '5px 35px 5px 20px !important',
  },
  '& .pro-inner-item:hover': {
    color: '#868dfb !important',
  },
  '& .pro-menu-item.active': {
    color: '#6870fa !important',
  },
});
